import React from 'react';

const initialState = {
  userRole: '',
  orgId: '',
  approverEmails: [],
  subOrgDetails: {}
};

const UserContext = React.createContext({
  ...initialState
});

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER_ROLE':
      return {
        ...state,
        userRole: action.payload
      };
    case 'SET_ORG_ID':
      return {
        ...state,
        orgId: action.payload
      };
    case 'SET_APPROVER_EMAILS':
      return {
        ...state,
        approverEmails: action.payload
      };
    case 'SET_SUBORG_DETAILS':
      return {
        ...state,
        subOrgDetails: action.payload
      };
    default:
      return { ...state };
  }
}

export const UserContextProvider = ({
  children
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const setUserRole = (payload) => {
    dispatch({
      type: 'SET_USER_ROLE',
      payload
    });
  }

  const setOrgId = (payload) => {
    dispatch({
      type: 'SET_ORG_ID',
      payload
    });
  }

  const setApproverEmails = (payload) => {
    dispatch({
      type: 'SET_APPROVER_EMAILS',
      payload
    });
  }

  const setSuborgDetails = (payload) => {
    dispatch({
      type: "SET_SUBORG_DETAILS",
      payload
    })
  }

  return (
    <UserContext.Provider value={{
      ...state,
      setUserRole,
      setOrgId,
      setApproverEmails,
      setSuborgDetails
    }}>
      {children}
    </UserContext.Provider>
  )
}

export default UserContext;